import script from "./CmsPages.vue?vue&type=script&setup=true&lang=js"
export * from "./CmsPages.vue?vue&type=script&setup=true&lang=js"

import "./CmsPages.vue?vue&type=style&index=0&id=5de7d367&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\banjara_matrimonial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de7d367"]])

export default __exports__